import React from "react";
import { ClassNameProps, makeClassName, scrollToBottom, StyleProps } from "@hex-insights/core";
import { MessageGroup, MessageGroupDetailQuery } from "../../../../Utilities";
import { Body } from "./Body";
import { Footer } from "./Footer";
import { Header } from "./Header";
import styles from "./styles.module.css";

export type DetailViewProps = {
	messageGroupID: MessageGroup["id"];
	messageGroup: MessageGroupDetailQuery["messageGroup"] | undefined;
} & Partial<ClassNameProps & StyleProps>;

export function DetailView({ messageGroupID, messageGroup, className, style }: DetailViewProps) {
	const ref = React.useRef<HTMLDivElement | null>(null);

	return (
		<div ref={ref} className={makeClassName(styles["message-group"], className)} style={style}>
			<DetailView.Header messageGroupID={messageGroupID} messageGroup={messageGroup} />
			<DetailView.Body messageGroupID={messageGroupID} messageGroup={messageGroup} />
			<DetailView.Footer messageGroupID={messageGroupID} onSuccess={scrollToBottom} dragStartElementRef={ref} />
		</div>
	);
}

DetailView.Header = Header;
DetailView.Body = Body;
DetailView.Footer = Footer;
